routes.$inject = ['$routeProvider'];

export default function routes($routeProvider) {
  $routeProvider
    .when('/oauth-completed', {
      resolve: {
        updateParent: ['$window', '$location',
          function ($window, $location) {
            // refresh parent window and close this child window
            var opener = $window.opener;
            var integration = $location.search()['integration']

            // the clio user auth flow may come from the welcome page or
            // the account page. when it's from the welcome page, redirect home.
            var path = integration === 'cliouser' &&
              !/account/g.test(opener && opener.location.href) ?
              '/app/#/home' :
              '/app/#/account?oauth-completed=' + (integration || 'box');

            if (opener) {
              opener.location.href = path;
              opener.location.reload();
            } else {
              $window.open(path);
            }

            $window.close();

          }
        ]
      }
    });
}



// WEBPACK FOOTER //
// ./project/pages/oauth-completed/oauth-completed.routes.js